<template>
<div class="lock-page">
	<div class="modal-window" :class="showMap ? 'showMapWindow' : ''">
		<div class="modal-content">
			<div v-if="showMap">
				<div class="map"></div>
			</div>
			<div v-else>
				<grid>
					<div alt="logo" class="logo" />
				</grid>
				<grid>
					<grid-item size="1/1">
						<h3>Enter your 24 digit security key to access this data</h3>
					</grid-item>
				</grid>
				<div class="lock-content">
					<grid>
						<grid-item size="1/1">
							<custom-input
								type="password"
								placeholder="xxxxxxxxxxxxxxxxxx"
								inputStyle="dark"
								v-model="key"
							/>
						</grid-item>
					</grid>
				</div>
				<button class="button primary" @click="showMap = true">
					show map
				</button>
			</div>
		</div>
	</div>
	<a @click="goBack()" class="back-button">
		X
	</a>
</div>
</template>

<script>
import CustomInput from '@/components/secondary/CustomInput'

export default {
	components: {
		CustomInput
	},
	data: () => ({
		key: null,
		showMap: false
	}),
	methods: {
		goBack() {
			if(this.showMap) {
				this.showMap = false
			} else {
				this.$router.push({
					name: 'opportunity',
					params: {
						opportunityId: this.$route.query.opportunityId
					},
					query: {
						...this.$route.query,
						opportunityId: undefined
					}
				})
			}
		}
	}
}
</script>

<style lang="scss">
.lock-page {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 56px;
	right: 0;
	z-index: 3;
	background: #0202029c;

	.modal-window.showMapWindow {
		top: 50% !important;

		.modal-content {
			padding: 10px;
		}
		.map {
			background-image: url('../../../assets/images/map.png');
			background-size: contain;
			height: 500px;
		}
	}
	.modal-window {
		top: 35% !important;
		left: 48% !important;
		width: 40% !important;
		
		h3 {
			color: #fff;
			font-size: 13px;
			text-transform: uppercase;
		}
		.modal-content {
			background-image: radial-gradient(
				circle at 50% 50%, 
				rgba(255, 255, 255, 0.36) 25%, 
				rgba(53, 74, 90, 0.39) 70%
			);
			padding-bottom: 15px;
			padding-top: 10px;
			border-color: rgba(255, 255, 255, 0.66);

			.logo {
				background: url('../../../assets/images/logo_light.svg');
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;
				width: 100px;
				margin: 0 auto;
			}

			.lock-content {
				background: #151a228f;
				padding: 10px 20px;

				.custom-input {
					input {
						text-align: center;
					}
				}
			}
		}
		hr {
			margin: 15px;
			width: 520px;
			margin-left: -40px;
		}
		.button {
			width: 150px;
			padding: 4px 13px;
			margin: 35px 0px 5px;
		}
	}

	.back-button {
		position: absolute;
		top: 0;
		right: 0;
		text-decoration: none;
		color: #fff;
		background: #3b9fcf;
		width: 55px;
		height: 55px;
		line-height: 55px;
		font-size: 36px;
		font-weight: 200;
		cursor: pointer;
	}
}
</style>
